module.exports = __webpack_public_path__ + "static/media/structurea_bold.3c94269a.svg";